/**
 * Pre-compiled fr-FR messages for DefaultPage
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default { backLink: `Retour` };
